import { render } from "./accessRequestCounselList.vue?vue&type=template&id=4ea2599c&ts=true"
import script from "./accessRequestCounselList.vue?vue&type=script&lang=ts&config=true"
export * from "./accessRequestCounselList.vue?vue&type=script&lang=ts&config=true"

import "./accessRequestCounselList.vue?vue&type=style&index=0&id=4ea2599c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__